import axiosPost from '../axiosPost';

export const monedasIns = async (arg) => {
    const { nombre, codigo, esBase } = arg;

    const body = {
        "service": "MonedaIns",
        "params": {
            "monedaNombre": nombre,
            "monedaCod": codigo,
            "monedaEsBase": esBase
        }
    }

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data
    } catch (err) {
        console.log(err)
    }
}